module.exports = __webpack_public_path__ + "img/romania.522828b0.svg";